import { IGif } from '@giphy/js-types'

const isAdInResult = (results: IGif[]) => {
    let adsFound = false
    for (var i = 0; i < 5; i++) {
        if (results[i] && results[i].bottle_data && Object.keys(results[i].bottle_data).length > 0) {
            adsFound = true
            break
        }
    }
    return adsFound
}

export default isAdInResult
